import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperclip } from "@fortawesome/free-solid-svg-icons";

import "./index.scss";

const LabelBadge = ({ label }) => (
  <div className="label-badge">
    <span className="icon">
      <FontAwesomeIcon icon={faPaperclip} />
    </span>
    <span>{label}</span>
  </div>
);

export default LabelBadge;
